import { render, staticRenderFns } from "./RecommendedSection.vue?vue&type=template&id=5e80c814&"
import script from "./RecommendedSection.vue?vue&type=script&lang=js&"
export * from "./RecommendedSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./RecommendedSection.vue?vue&type=custom&index=0&blockType=translations"
if (typeof block0 === 'function') block0(component)

export default component.exports